import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '@kimaya/ngx-auth-service';
import { OrganisationService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  /**
   * Constructor
   *
   * @param {AuthService} authService
   * @param {Router} _router
   */
  constructor(
    private authService: AuthService,
    private organisationService: OrganisationService,
    private _router: Router
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check the authenticated status
   *
   * @param redirectURL
   * @private
   */
  private _check(redirectURL): Observable<boolean> {
    // If the user is not authenticated...
    /*if (!this.organisationService.organisationId) {
      this._router.navigate(['org/select-org'], {queryParams: {redirectURL}});
    }*/
    if (!this.authService.isLoggedIn()) {
      // Redirect to the sign-in page
      this._router.navigate(['sign-in'], {queryParams: {redirectURL}});

      // Prevent the access
      return of(false);
    }

    // Allow the access
    return of(true);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let redirectUrl = state.url;

    if (redirectUrl === '/sign-out') {
      redirectUrl = '/';
    }

    return this._check(redirectUrl);
  }

  /**
   * Can activate child
   *
   * @param childRoute
   * @param state
   */
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let redirectUrl = state.url;

    if (redirectUrl === '/sign-out') {
      redirectUrl = '/';
    }

    return this._check(redirectUrl);
  }

  /**
   * Can load
   *
   * @param route
   * @param segments
   */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this._check('/');
  }
}
